// extracted by mini-css-extract-plugin
module.exports = {"Success":"FormSuccess_Success__7cbz3","Icon":"FormSuccess_Icon__PUZRR","Title":"FormSuccess_Title__ayHdo","Subtitle":"FormSuccess_Subtitle__eT85W","Text":"FormSuccess_Text__JIfCI"};